import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAYMONEY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {
    NavigationResult,
    NavigationTypeSelectableParam,
    PopupMessageReceiveParam,
    ReturnUrlComposerParam,
    ThunkApi,
} from '../interfaces'

const PAYMONEY_ACCOUNT_REGISTRATION_URL = `${PAYMONEY}/account-registration-bridge`

const POPUP_KEY = 'REGISTER_PAY_MONEY_CHARGE_ACCOUNT'
const MESSAGE_KEY = 'paymethod_registration_paymoney_charge_account'

const navigateToPayMoneyAccountRegister = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & PopupMessageReceiveParam & ReturnUrlComposerParam) | void,
    ThunkApi
>('navigateTo/payMoneyAccountRegister', async (args) => {
    const {forceLocationChange = false, bridgeUrl = ''} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: PAYMONEY_ACCOUNT_REGISTRATION_URL,
            query: {
                rurl: window.location.href,
                curl: window.location.href,
            },
        })

        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    return new Promise<void | string>((resolve, reject) => {
        const resolveCallback = (result: {message: string}) => {
            if (result.message === 'success') {
                return resolve(result.message)
            }

            resolve()
        }

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: PAYMONEY_ACCOUNT_REGISTRATION_URL,
            popupQuery: {
                rurl: `${bridgeUrl}/${MESSAGE_KEY}/success`,
                curl: `${bridgeUrl}/${MESSAGE_KEY}/fail`,
            },
            title: '페이머니 계좌등록',
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToPayMoneyAccountRegister
